/** Task item state flags for style computation. */
import {
  getTaskStateFlags,
  hasAccentBorder,
  selectionIdsForList,
} from '@/features/tasks/utils/ui/taskItemStyleUtils';
import { isOverdueDate } from '@/features/tasks/utils/views/taskTimeUtils';

export function buildTaskItemFlags({
  task,
  allContexts,
  localCompleted,
  isFocused,
  isDragging,
  isOver,
  isOverlay,
  ui,
}) {
  const selectedTaskIds = selectionIdsForList(
    ui.selectedTaskIds,
    ui.listId,
    ui.focusOwnerId,
  );
  const stateFlags = getTaskStateFlags(
    task,
    ui.plannedParentIds,
    ui.waitingForParentIds,
    selectedTaskIds,
    ui.duplicateOrderKeyTaskIds,
  );
  const isOverdue = isOverdueDate(task?.date);

  return {
    ...stateFlags,
    localCompleted,
    isListFocused: ui.isListFocused,
    isDragging,
    isDropTarget: isOver && !isDragging,
    isOverlay,
    isFocused,
    hasAccentBorder: hasAccentBorder(
      stateFlags.isWaitingFor,
      allContexts,
      isOverdue,
    ),
    isOverdue,
  };
}
